import React, { createContext, useContext, useReducer } from 'react';
import { getSessionStorageItem } from 'utils';
import reducer from './reducer';

export const initialState = {
  appState: '',
  applicationStatus: 'Live',
  defaultPrinter: getSessionStorageItem({ item: 'defaultPrinter' }) || '',
  notifications: [],
  printers: [],
}

export const AppStateContext = createContext();
export const AppDispatchContext = createContext();

function AppContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppStateContext.Provider>
  )
}

function useAppDispatch() {
  const context = useContext(AppDispatchContext)
  if (context === undefined) {
    throw new Error('useAppDispatch must be used within a AppState Provider')
  }
  return context
}

function useAppState() {
  const context = useContext(AppStateContext)
  if (context === undefined) {
    throw new Error('useAppState must be used within a AppState Provider')
  }
  return context
}

export { AppContext, useAppDispatch, useAppState };